import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router';
import Dashboard from './Dashboard';
import Email from './Email';
import Page from './Page';
import UploadHtml from './UploadHtml';
import UploadImages from './UploadImages';
import NewFromTemplate from './NewFromTemplate';
import QRCode from './QRCode';
import SurveyEditor from './SurveyEditor';
import NewSurveyFromTemplate from './NewSurveyFromTemplate';
import SurveyResults from './SurveyResults';
import SurveyPreview from './SurveyPreview';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import useSuspenseFetch from '../hooks/useSuspenseFetch';
import SplashScreen from '../splashScreen/SplashScreen';

const Editor = () => {
    const { data: user } = useSuspenseFetch('user');

    const hasCreateAndSendPermission = user.permissions.includes('Manage Create & Send');

    if (!hasCreateAndSendPermission) {
        return (
            <Paper sx={{ padding: 6, textAlign: 'center' }}>
                <Typography>You don't have permission to manage Create & Send.</Typography>
                <Typography>Please contact your account administrator to have this enabled.</Typography>
            </Paper>
        );
    }

    return (
        <Suspense fallback={<SplashScreen />}>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path=":type/new" element={<NewFromTemplate />} />
                <Route path=":type/upload" element={<UploadHtml />} />
                <Route path=":type/:id/upload-images" element={<UploadImages />} />
                <Route path="email/:id" element={<Email />} />
                <Route path="email/:id/send" element={<Email emailStep={1} />} />
                <Route path="page/:id" element={<Page />} />
                <Route path="qr/:id" element={<QRCode />} />
                <Route path="surveys/new-survey" element={<NewSurveyFromTemplate />} />
                <Route path="surveys/:id" element={<SurveyEditor />} />
                <Route path="surveys/:id/results" element={<SurveyResults />} />
                <Route path="surveys/:id/preview" element={<SurveyPreview />} />
            </Routes>
        </Suspense>
    );
};

export default Editor;